import type { TxSummary } from '@apm/contracts';

/**
 * 끝난 요청 목록에서 고른 서비스의 마지막 `count`건을 **새것부터** 고른다 (D-C5).
 *
 * `rows.filter(...).slice(-count).reverse()`와 같은 결과다. 다만 5만 행 전체를 거르지 않고
 * 뒤에서부터 `count`건을 찾으면 멈춘다. 목록은 끝난 시각 순이라 뒤가 새것이다.
 */
export function lastRowsOf(
  rows: readonly TxSummary[],
  service: string,
  count: number,
): TxSummary[] {
  const out: TxSummary[] = [];
  for (let index = rows.length - 1; index >= 0 && out.length < count; index -= 1) {
    const row = rows[index] as TxSummary;
    if (row.service === service) out.push(row);
  }
  return out;
}
